export default __webpack_public_path__ + "static/media/partner-liefering.8d1b870e.webp";